export default "__VITE_ASSET__dtS3HrzH__"